import { defineMessages } from 'react-intl';

export const scope = 'app.containers.TextMessageCases';

export default defineMessages({
  useFormula: {
    id: `${scope}.useFormula`,
    defaultMessage: 'Use formula',
  },
});
